import { css } from '@migros/msrc-ui-kit';
export const migrosAppRatingNumber = css`
  font-weight: ${({
  theme: {
    fonts
  }
}) => fonts.weights.bold};
`;